import { render, staticRenderFns } from "./mould.vue?vue&type=template&id=5ae8cdcc"
import script from "./mould.vue?vue&type=script&lang=js"
export * from "./mould.vue?vue&type=script&lang=js"
import style0 from "./mould.vue?vue&type=style&index=0&id=5ae8cdcc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports